import React from 'react';

import { importData as importOverview } from './Overview';
import { importData as importProduction } from './Production';
import { importData as importStop } from './Stop';
import { importData as importRealTime } from './RealTime';
import { importData as importScrap } from './Scrap';
import { importData as importCost } from './Cost';
import { importData as importQuality } from './Quality';
import { importData as importRankIndicators } from './RankIndicators';
import { importData as importReport } from './Report';
import { importData as importBoard } from './Board';
import { importData as importStock } from './Stock';

export default function importData() {
    
    importOverview();
    importProduction();
    importStop();
    importRealTime();
    importScrap();
    importCost();
    importQuality();
    importRankIndicators();
    importReport();
    importBoard();
    importStock();
}